import culture1 from '../assets/images/culture1.png';
import culture2 from '../assets/images/culture2.png';
import culture3 from '../assets/images/culture3.png';
import culture4 from '../assets/images/culture4.png';
import culture5 from '../assets/images/culture5.png';
import culture6 from '../assets/images/culture6.png';
import culture7 from '../assets/images/culture7.png';
import culture8 from '../assets/images/culture8.png';
import culture9 from '../assets/images/culture9.png';
import culture10 from '../assets/images/culture10.png';

export default [
  {
    sn: '01',
    img: culture1
  },
  {
    sn: '02',
    img: culture2
  },
  {
    sn: '03',
    img: culture3
  },
  {
    sn: '04',
    img: culture4
  },
  {
    sn: '05',
    img: culture5
  },
  {
    sn: '06',
    img: culture6
  },
  {
    sn: '07',
    img: culture7
  },
  {
    sn: '08',
    img: culture8
  },
  {
    sn: '09',
    img: culture9
  },
  {
    sn: '10',
    img: culture10
  }
];
